module.exports = __webpack_public_path__ + "static/media/covidstories_cover6.3442ce86.jpg";